import styles from 'styles/modules/Quote.module.scss';

const Quote = ({ quote }) => {
    if (!quote) return null;

    let author = null;

    if (quote.author) {
        author = (
            <div className={styles.author}>
                <div className={styles.authorImage}>
                    {/*<img src={quote.author.image} alt={quote.author.name} />*/}
                </div>
                <div className={styles.authorBody}>
                    <strong>{quote.author.name}</strong>
                    <small>{quote.author.sub}</small>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.wrapper}>
            <blockquote className={styles.quote}>{quote.quote}</blockquote>
            {author}
        </div>
    );
};

export default Quote;
